import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';
const LABELS = {
    selectable: 'Selectable',
    suspended: 'Suspended',
    'out-of-bounds': 'Out of bounds',
    started: 'Started',
};
const verdictVariants = cva('inline-flex items-center gap-1.5 whitespace-nowrap rounded-[6px] px-2 py-[3px] font-ui text-[11px] font-semibold leading-[1.3]', {
    variants: {
        verdict: {
            selectable: 'bg-verdict-selectable-bg text-verdict-selectable-text',
            suspended: 'bg-verdict-suspended-bg text-verdict-suspended-text',
            'out-of-bounds': 'bg-verdict-outofbounds-bg text-verdict-outofbounds-text',
            started: 'bg-verdict-started-bg text-verdict-started-text',
        },
    },
    defaultVariants: { verdict: 'selectable' },
});
export function VerdictBadge({ verdict = 'selectable', className, ...rest }) {
    return (_jsx("span", { "data-verdict": verdict, className: cn(verdictVariants({ verdict }), className), ...rest, children: LABELS[verdict] ?? verdict }));
}
//# sourceMappingURL=verdict-badge.js.map